import { Loading } from 'pages/loading/ui/loading.page';
import React from 'react';
import { useParams } from 'react-router-dom';
import { CreateEmployeeForm, Header } from 'widgets';
import { PageLayout } from 'shared/ui';
import { OnboardingStepIndicator } from 'features/onboarding';

export const CreateEmployeePage: React.FC = () => {
  const { id } = useParams();

  return id ? (
    <>
      <OnboardingStepIndicator />
      <PageLayout>
        <Header />
        <CreateEmployeeForm pointId={id} />
      </PageLayout>
    </>
  ) : (
    <Loading />
  );
};
